import styled from 'styled-components';
import { PropertyItem } from '../PropertyGroup';
export var Section = styled.section.withConfig({
  displayName: "OrderBystyles__Section",
  componentId: "keen-query-creator__sc-r3iurm-0"
})(["&&&{display:flex;position:relative;}"]);
export var StyledPropertyItem = styled(PropertyItem).withConfig({
  displayName: "OrderBystyles__StyledPropertyItem",
  componentId: "keen-query-creator__sc-r3iurm-1"
})(["&&&{background:none;}"]);
export var SortableContainer = styled.div.withConfig({
  displayName: "OrderBystyles__SortableContainer",
  componentId: "keen-query-creator__sc-r3iurm-2"
})(["&&&{display:flex;flex-wrap:wrap;}"]);
export var OrderByContainer = styled.div.withConfig({
  displayName: "OrderBystyles__OrderByContainer",
  componentId: "keen-query-creator__sc-r3iurm-3"
})(["&&&{margin-right:10px;margin-bottom:10px;}&&&[draggable='true'] .drag-handle{cursor:grabbing;}&&&:last-child{margin-right:0;}"]);